var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Avatar, Breadcrumbs, IconButton, Typography, useMediaQuery, Link as MuiLink, styled, Badge as MuiBadge, } from '@mui/material';
import React, { useContext, useLayoutEffect } from 'react';
import { Menu as MenuIcon } from '@mui/icons-material';
import { UserDropdown } from './UserDropdown';
import { Link } from 'react-router-dom';
import useNotifications from './hooks/useNotifications';
export var MadboxNavbarContext = React.createContext({
    content: {},
    setContent: function () { },
    removeContent: function () { },
});
var Badge = styled(MuiBadge)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  & .MuiBadge-badge {\n    top: 5px;\n  }\n"], ["\n  & .MuiBadge-badge {\n    top: 5px;\n  }\n"])));
var NavContainer = styled(Box)(function (_a) {
    var theme = _a.theme;
    return ({
        width: '100%',
        '& .MuiTabs-root': {
            width: 'max-content',
            margin: 'auto',
            maxWidth: '100%',
        },
    });
});
export var ContextualizedNavbarContent = React.memo(function (props) {
    var _a;
    var setMenuOpen = props.setMenuOpen, menuOpen = props.menuOpen, user = props.user;
    var context = useContext(MadboxNavbarContext);
    var small = useMediaQuery(function (theme) { return theme.breakpoints.down('md'); });
    var _b = React.useState(null), anchorEl = _b[0], setAnchorEl = _b[1];
    var notifs = useNotifications({ enabled: !!user });
    return (_jsx(_Fragment, { children: _jsxs(Box, __assign({ sx: { width: '100%' } }, { children: [_jsxs(Box, __assign({ sx: { display: 'flex', alignItems: 'center', height: 50 } }, { children: [small && !menuOpen && (_jsx(IconButton, __assign({ edge: "start", sx: { marginRight: 1 }, onClick: function () { return setMenuOpen(true); } }, { children: _jsx(MenuIcon, {}, void 0) }), void 0)), _jsxs(Breadcrumbs, __assign({ sx: { width: '100%' } }, { children: [context.content &&
                                    context.content.breadcrumbs &&
                                    context.content.breadcrumbs.map(function (b) { return (_jsx(Link, __assign({ component: MuiLink, to: b.href }, { children: b.title }), b.href)); }), !context.content || typeof context.content.title === 'string' ? (_jsx(Typography, __assign({ sx: { fontWeight: 700, color: 'text.primary' } }, { children: (context.content && context.content.title) || 'Madbox Games' }), void 0)) : (context.content.title)] }), void 0), user ? (_jsxs(_Fragment, { children: [_jsx(IconButton, __assign({ size: "small", onClick: function (event) { return setAnchorEl(event.currentTarget); } }, { children: _jsx(Badge, __assign({ badgeContent: (_a = notifs.data) === null || _a === void 0 ? void 0 : _a.unread, color: "primary" }, { children: _jsx(Avatar, { src: user.picture_url || undefined, alt: user.firstname || undefined }, void 0) }), void 0) }), void 0), _jsx(UserDropdown, { anchorEl: anchorEl, onClose: function () { return setAnchorEl(null); } }, void 0)] }, void 0)) : null] }), void 0), context.content && context.content.children && _jsx(NavContainer, { children: context.content.children }, void 0)] }), void 0) }, void 0));
});
/**
 * Children of this component will be displayed in the header's navigation toolbar.
 *
 * It should contain navigation components.
 *
 * @example
 * <NavbarContent title="Page name" breadcrumbs={[{ title: "Previous", href: "/" }]}>
 *   <TabsNav>
 *     <LinkTab value="/" label="Home" />
 *     <LinkTab value="/test" label="Test" />
 *   </TabsNav>
 * </NavbarContent>
 *
 * @param props
 * @returns
 */
export var NavbarContent = React.memo(function (props) {
    var context = useContext(MadboxNavbarContext);
    useLayoutEffect(function () {
        context.setContent(props);
        return function () { return context.removeContent(props); };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props]);
    return null;
});
var templateObject_1;
